import { render, staticRenderFns } from "./trading_activity_detail.vue?vue&type=template&id=1419ed94"
import script from "./trading_activity_detail.vue?vue&type=script&lang=js"
export * from "./trading_activity_detail.vue?vue&type=script&lang=js"
import style0 from "./trading_activity_detail.vue?vue&type=style&index=0&id=1419ed94&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports